import Rete from "rete";
import VueTextControl from "./TextControl.vue";

export class TextControl extends Rete.Control {
  constructor(key, label, readonly = false, multiline = 0, inputType = 'text') {
    super(key);
    this.component = VueTextControl;
    this.props = { ikey: key, label, readonly, multiline, inputType };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}
